import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterReport from 'views/customers/reports/betsReport/filterReport'; // Importing FilterReport component
import TableReport from 'views/customers/reports/betsReport/tableReport'; // Importing TableReport component
import TableTransactionsReport from 'views/customers/reports/betsReport/recordTransReport'; // Importing TableTransactionsReport component
import RecordReport from 'views/customers/reports/betsReport/recordReport'; // Importing RecordReport component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * BetsReportView class extends JetView to create a report view for bets.
 */
export default class BetsReportView extends JetView {
    /**
     * Configures the layout of the BetsReportView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            // Right section configuration
            type: 'wide',
            minWidth: 200,
            rows: [RecordReport, TableTransactionsReport], // Contains RecordReport and TableTransactionsReport
        };
        const right2 = {
            // Alternative right section for smaller screens
            height: 1,
            id: 'right2',
            width: screen.width - 54,
            type: 'wide',
            rows: [RecordReport, TableTransactionsReport],
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                // Toolbar columns
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager for navigation
                    id: 'pagerA1',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' },
                        { id: '2', value: 'PDF' },
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // First item index
                            var last = first + size - 1; // Last item index
                            if (value == 1) {
                                // If Excel export is selected
                                var table = $$('datatable');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Apuestas'),
                                    ignore: { detailTittle: true },
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF export is selected
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Apuestas'),
                                        autowidth: true,
                                        ignore: { detailTittle: true },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            // Left section configuration
            rows: [
                {
                    view: 'toolbar', // Search toolbar
                    css: theme,
                    id: 'toolbar-search',
                    elements: [
                        { view: 'label', label: _('Reporte de Apuestas') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search',
                            cols: [
                                {
                                    view: 'icon', // Search icon
                                    icon: 'wxi-search',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        // Click event to show filter popup
                                        $$('filterPopup').show();
                                    },
                                },
                            ],
                        },
                    ],
                },
                FilterReport, // FilterReport component
                TableReport, // TableReport component
                toolbar, // Toolbar component
            ],
        };
        const avanc = {
            // Advanced details accordion
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Right section in accordion
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen
        return {
            // Main layout configuration
            id: 'a5',
            type: 'clean',
            view: 'form',
            scrollY: screen.width < 820 ? false : true, // Conditional scrolling
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left section
                        screen.width < 500 || screen.height < 500
                            ? right2 // Use right2 for small screens
                            : avanc, // Use advanced details for larger screens
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the BetsReportView.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screens
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the third child view
                $$('pagerA1').define('group', 1); // Define pager group
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screens
                $$('toolbar-search').hide(); // Hide search toolbar
            }
            $.fn.scrollBottom = function () {
                // jQuery function to calculate scroll bottom
                return $(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
